import React from 'react';

class IconFacebookComponent extends React.Component {
  render() {
    const { className, color = 'currentColor' } = this.props;

    return (
      <svg
        className={className}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
      >
        <g fill={color} fillRule="evenodd">
          <path d="M21.667 10.9c0-6.02-4.85-10.9-10.834-10.9C4.851 0 0 4.88 0 10.9c0 5.439 3.962 9.95 9.141 10.767V14.05h-2.75V10.9h2.75V8.497c0-2.731 1.618-4.24 4.092-4.24 1.185 0 2.424.213 2.424.213v2.682h-1.366c-1.345 0-1.764.84-1.764 1.702V10.9h3.004l-.48 3.15h-2.524v7.618c5.179-.817 9.14-5.328 9.14-10.768" />
        </g>
      </svg>
    );
  }
}

export default IconFacebookComponent;
